(() => {
  const ADDON_VARIANT_ID = 58024311390590;
  const root = document.getElementById('smash-customizer');
  if (!root) return;

  const intro = root.querySelector('.scpdp__intro');
  if (intro) intro.remove();

  const sleeveField = root.querySelector('.scpdp__sleeve-field');
  if (sleeveField) {
    const priceNote = sleeveField.querySelector('[data-sleeve-price]');
    const updatePriceNote = (selected) => {
      if (!priceNote) return;
      priceNote.textContent = selected ? '+$13.99 added to your hoodie' : 'Optional add-on · +$13.99';
      priceNote.classList.toggle('is-added', selected);
    };
    updatePriceNote(false);

    sleeveField.querySelectorAll('[data-sleeve-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        updatePriceNote(button.dataset.sleeveChoice === 'Yes');
      });
    });

    const sleeveInput = sleeveField.querySelector('[data-sleeve-text]');
    if (sleeveInput) {
      sleeveInput.maxLength = 12;
      sleeveInput.setAttribute('maxlength', '12');
    }

    const sleeveHelp = sleeveField.querySelector('.scpdp__sleeve-input small');
    if (sleeveHelp) sleeveHelp.textContent = 'Keep it short. Make it yours.';
  }

  const form = root.querySelector('.scpdp__form');
  if (!form || form.dataset.sleeveAddonReady === '1') return;
  form.dataset.sleeveAddonReady = '1';

  form.addEventListener('submit', async (event) => {
    const sleeveProperty = form.querySelector('[data-sleeve-property]');
    if (!sleeveProperty || sleeveProperty.value !== 'Yes') return;

    event.preventDefault();
    if (form.dataset.addingSleeveAddon === '1') return;

    const sleeveText = form.querySelector('[data-sleeve-text]');
    const wording = sleeveText ? sleeveText.value.trim() : '';

    if (!wording) {
      if (sleeveText) {
        sleeveText.setCustomValidity('Please enter your sleeve text.');
        sleeveText.reportValidity();
        sleeveText.focus();
      }
      return;
    }

    if (sleeveText) sleeveText.setCustomValidity('');
    form.dataset.addingSleeveAddon = '1';

    const addButton = form.querySelector('[data-add]');
    if (addButton) addButton.disabled = true;

    let mainItem = null;

    try {
      const mainResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      mainItem = await mainResponse.json();
      if (!mainResponse.ok) {
        throw new Error(mainItem?.description || mainItem?.message || 'Unable to add the hoodie to cart.');
      }

      const addonResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: ADDON_VARIANT_ID,
            quantity: 1,
            properties: {
              '_Smash add-on': 'Sleeve text',
              '_Sleeve wording': wording,
              '_For variant': form.querySelector('[data-variant-id]')?.value || ''
            }
          }]
        })
      });

      if (!addonResponse.ok) {
        let addonError = {};
        try { addonError = await addonResponse.json(); } catch (_) {}

        if (mainItem?.key) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ id: mainItem.key, quantity: 0 })
            });
          } catch (_) {}
        }

        throw new Error(addonError?.description || addonError?.message || 'Unable to add sleeve personalisation.');
      }

      window.location.assign('/cart');
    } catch (error) {
      console.error('[Smash Club sleeve add-on]', error);
      window.alert(error?.message || 'We couldn’t add the personalisation. Please try again.');
      form.dataset.addingSleeveAddon = '';
      if (addButton) addButton.disabled = false;
    }
  });
})();
